const GCP_SIZE_GUIDE_PREFIX = "GcpSizeGuide";

export const GCP_SIZE_GUIDE_CLASSES = {
  title: `${GCP_SIZE_GUIDE_PREFIX}-title`,
  description: `${GCP_SIZE_GUIDE_PREFIX}-description`,
  table: `${GCP_SIZE_GUIDE_PREFIX}-table`,
};
